"use strict";
exports.__esModule = true;
exports.CREDIT_BUILDER_CUSTOMIZE_SCHEDULE_CONTENT = void 0;
exports.CREDIT_BUILDER_CUSTOMIZE_SCHEDULE_CONTENT = {
    HEADER: 'When do you want to pay Flex each month?',
    SUB_HEADER: 'You’ll need to fund your account before using Flex for the first time, but each month after you can choose when to make your rent payment to Flex.',
    CTA: 'Continue',
    ERROR: 'Choose date to continue',
    NUDGE: '☝️ Flex submits your rent payment after you pay. Make sure your property won’t add late fees for rent payments made after the 1st.'
};
